export default "__VITE_ASSET__CMAleuvl__"